module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_6.8029f8f8.png";